/*
 * ******************************************************************
 * Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, ElementRef } from "@angular/core";
import { VmwTask, VmwTaskPanelComponent, VmwTasksService } from "@vmw/ngx-components";
import { VmwSimpleTranslateService } from "@vmw/ngx-utils";

// TODO: Remove TaskPanel customization together with the suboptimal inclusion of styles here.
@Component({
    standalone: false,
               selector: "vmw-task-panel-wrap",
               templateUrl: "vmw-task-panel-wrap.component.html",
                styleUrls: ["vmw-task-panel-wrap.component.scss"]
           })
export class VmwTaskPanelWrapComponent extends VmwTaskPanelComponent {

    constructor(vmwTasksService: VmwTasksService,
                element: ElementRef,
                translateService: VmwSimpleTranslateService) {
        super(vmwTasksService, element, translateService);
    }

    launchTaskTrigger(length: number): any {
        // weird behavior using this.element.nativeElement.clientHeight,
        // use this instead.
        const height = document.querySelector("vmw-task-panel-wrap").clientHeight;
        return {
            value: length,
            params: {
                startHeight: height
            }
        };
    }

    get showSummary(): boolean {
        return this.state === "collapsed";
    }

    get willShowSummary(): boolean {
        return this.state === "collapsed";
    }

    get showTasks(): boolean {
        return this.state === "open";
    }

    get showTasksSummarized(): boolean {
        return this.state === "collapsed";
    }

    toggleOthers(unused1: boolean, unused2: number): void {
        this.focused = false;
    }

    handleCustomAction(task: VmwTask): void {
        super.handleCustomAction(task);
        this.toggleState();
    }
}
